import React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import QueryStringNavigate from '../../../QueryStringNavigate';

import sunheroLogoColored from '../../../../images/sunheroLogo.svg';

import * as S from './NavHeader.styles';

import useWindowSize from '../../../../hooks/useWindowSize';

const NavHeader = ({ isOpen, setIsOpen }) => {
  const { t } = useTranslation(['navigation']);
  const handleClose = () => setIsOpen(!isOpen);
  const { width } = useWindowSize();

  return (
    <S.NavHeaderWrapper id="navHeader">
      <S.LogoWrapper>
        <QueryStringNavigate path="/">
          <S.LogoImg
            src={sunheroLogoColored}
            width="131"
            height="40"
            alt="Sunhero Logo"
          />
        </QueryStringNavigate>
        {width <= 500 && (
          <S.SunheroMotto
            data-testid="sunheroMottoMobile"
            id="sunheroMotto"
            className={isOpen ? 'open' : ''}
            isOpen={isOpen}
          >
            {t('motto')}
          </S.SunheroMotto>
        )}
      </S.LogoWrapper>

      <S.CloseWrapper
        data-testid="hamburger"
        role="button"
        onClick={handleClose}
        isOpen={isOpen}
      >
        <S.Line />
        <S.Line />
      </S.CloseWrapper>
    </S.NavHeaderWrapper>
  );
};

export default NavHeader;
